import { Cloud, RefreshCw } from "lucide-react";

/**
 * Subtle "Monday synced" trust badge. Reads `source_of_truth` +
 * `last_synced_at` from any doc stamped by the Monday orchestrator or
 * the inbound webhook. Renders nothing when the doc has never synced.
 *
 * source_of_truth === "app"    → cyan, "Synced to Monday · Xm ago"
 * source_of_truth === "monday" → violet, "Updated on Monday · Xm ago"
 */
const timeAgo = (iso) => {
  if (!iso) return "";
  const diff = Date.now() - new Date(iso).getTime();
  const mins = Math.floor(diff / 60000);
  if (mins < 1) return "just now";
  if (mins < 60) return `${mins}m ago`;
  const hrs = Math.floor(mins / 60);
  if (hrs < 24) return `${hrs}h ago`;
  return `${Math.floor(hrs / 24)}d ago`;
};

const SyncBadge = ({ source, syncedAt, compact = false }) => {
  if (!source || !syncedAt) return null;
  const isMonday = source === "monday";
  const Icon = isMonday ? Cloud : RefreshCw;
  const accent = isMonday ? "#a78bfa" : "#00f0ff";
  const label = isMonday ? "Updated on Monday" : "Synced to Monday";

  return (
    <span
      data-testid={`sync-badge-${source}`}
      title={`${label} · ${new Date(syncedAt).toLocaleString()}`}
      className="inline-flex items-center gap-1 rounded-full border px-2 py-[3px] text-[10px] uppercase tracking-[0.16em] font-medium"
      style={{
        borderColor: `${accent}33`,
        background: `${accent}0f`,
        color: accent,
      }}
    >
      <Icon size={10} strokeWidth={2.2} />
      {!compact && (
        <>
          <span className="whitespace-nowrap">{label}</span>
          <span className="opacity-70">· {timeAgo(syncedAt)}</span>
        </>
      )}
      {compact && <span>{timeAgo(syncedAt)}</span>}
    </span>
  );
};

export default SyncBadge;
